/**
 * Hotspot Image
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.hotspot-image',

	events: {
		'click .hotspot-image__container__hotspots__spot__btn': 'onSpotClick',
		click: 'setSpotInactive',
	},

	initialize() {
		window.addEventListener('resize', this.onResize.bind(this));
	},

	setSpotActive(element) {
		element.classList.add('active');
		this.setTooltipContentMobile(element);
		if (window.innerWidth >= 768) {
			this.setDesktopTooltipPos(element, this);
		}
	},

	setSpotInactive() {
		const activeSpot = this.el.querySelector('.hotspot-image__container__hotspots__spot.active');
		if (activeSpot) {
			activeSpot.classList.remove('active');
			this.removeTooltipContentMobile();
			this.el.style.paddingBottom = 0;
		}
	},

	onSpotClick(e) {
		e.stopImmediatePropagation();

		const spot = e.delegateTarget.parentNode;

		if (spot.classList.contains('active')) {
			this.setSpotInactive();
		} else {
			this.setSpotInactive();
			this.setSpotActive(spot);
		}
	},

	removeTooltipContentMobile() {
		const contentMobile = this.el.querySelector('.hotspot-image__text-content-mobile');
		contentMobile.classList.remove('tooltip-visible');
		const tooltipContainer = this.el.querySelector('.hotspot-image__text-content-mobile__tooltip');
		tooltipContainer.innerHTML = '';
	},

	setTooltipContentMobile(element) {
		const contentMobile = this.el.querySelector('.hotspot-image__text-content-mobile');
		contentMobile.classList.add('tooltip-visible');
		const tooltipContainer = this.el.querySelector('.hotspot-image__text-content-mobile__tooltip');

		const contentToSet = {
			label: element.querySelector('.js-hotspot-spot-label').cloneNode(true),
			text: element.querySelector('.js-hotspot-spot-text').cloneNode(true),
		};
		tooltipContainer.appendChild(contentToSet.label);
		tooltipContainer.appendChild(contentToSet.text);
	},

	setDesktopTooltipPos(element, $this) {
		const hotspotContainer = this.el.querySelector('.hotspot-image__container__hotspots');
		const spot = element.closest('.active');
		const btn = element.querySelector('.hotspot-image__container__hotspots__spot__btn');
		const tooltip = element.querySelector('.hotspot-image__container__hotspots__spot__tooltip-desktop');
		const tooltipArrow = tooltip.querySelector('.js-hotspot-spot-arrow');
		const leftWindowSpace = window.innerWidth * 0.1;

		const parentTranslateX = 35;
		const halfRemainingSpace = (window.innerWidth - tooltip.offsetWidth) / 2;

		const parent = {
			offsetTop: spot.offsetTop,
			offsetLeft: spot.offsetLeft,
		};

		const tooltipBottom = hotspotContainer.offsetHeight - (parent.offsetTop + tooltip.offsetHeight + btn.offsetHeight + 40);
		if (tooltipBottom < 0) {
			$this.el.style.paddingBottom = `${Math.abs(tooltipBottom) + 50}px`;
		}
		if ((spot.offsetLeft - (spot.offsetWidth / 2)) <= leftWindowSpace) { // if spot has a lower x axis value than tooltip box
			tooltip.style.left = 0;
		} else if (spot.offsetLeft > (leftWindowSpace + tooltip.offsetWidth)) { // if spot has a greater x axis value than tooltip box
			const missingSpace = spot.offsetLeft - (leftWindowSpace + tooltip.offsetWidth);
			tooltip.style.left = `${-(parent.offsetLeft - parentTranslateX) + halfRemainingSpace + missingSpace + (btn.offsetWidth / 2)}px`;
		} else { // if spot x axis value is in between the width of the tooltip box
			tooltip.style.left = `${-(parent.offsetLeft - parentTranslateX) + halfRemainingSpace}px`;
		}

		const spotOffsetFromTooltipLeft = Math.abs(tooltip.offsetLeft) + (tooltipArrow.offsetWidth / 2) + 5;

		tooltipArrow.style.left = `${spotOffsetFromTooltipLeft}px`;
	},

	onResize() {
		const activeSpot = this.el.querySelector('.hotspot-image__container__hotspots__spot.active');
		if (window.innerWidth >= 768 && activeSpot) {
			this.setDesktopTooltipPos(activeSpot, this);
		} else {
			this.el.style.paddingBottom = 0;
		}
	},
});

export default View;
